// ====================================================================================
// main.js
// ====================================================================================

import("./modules/usercentrics.module.js").then((module) => module.init());

if (document.querySelector(".asuc-accept")) {
  import("./modules/iframes.module.js").then((module) => module.init());
}

if (document.querySelector("#scriptUTT")) {
  import("./modules/utt.module.js").then((module) => module.init());
}

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
// let attempts = 0;
// const whenComplete = () => {
//   if (++attempts > 30) return;
//   if (document.readyState === "complete") {
//     // --- code ---
//   } else {
//     setTimeout(() => whenComplete(), 400);
//   }
// };
// whenComplete();
